import Vue from 'vue'
import Router from 'vue-router'
import shareHome from '@/views/share/home'
import myQr from "../views/share/myQr";
import addFriend from "../views/share/addFriend";
import confirm from "../views/share/confirm";
import apply from "../views/share/apply";
import privilege from "../views/share/privilege";
import phone from "../views/share/phone";
import qrResult from "../views/share/qrResult";
import confirmAdd from "../views/share/confirmAdd";
import friendList from "../views/share/friendList";
import applyList from "../views/share/applyList";
import sportRank from "../views/share/sportRank";
import qrAdd from "../views/share/qrAdd";
import friendDesc from "../views/share/friendDesc";
import condition from "../views/share/condition";
import forecast from "../views/share/forecast";
import personal from "../views/share/personal";
import hrRange from "../views/share/hrRange";
import find from "../views/share/find";
import selectCity from "../views/share/selectCity";
import unReadList from "../views/share/unReadList";
import msgDesc from "../views/share/msgDesc";
import allDynamics from "../views/share/allDynamics";
import remarkSet from "../views/share/remarkSet";
import weekly from "../views/report/weekly";
import month from "../views/report/month";
import list from "../views/report/list";
import monthHistory from "../views/report/monthHistory";
import weeklyHistory from "../views/report/weeklyHistory";
import iosMessageSet from "../views/article/iosMessageSet";
import samSet from "../views/article/samSet";
import androidMessageSet from "../views/article/androidMessageSet";
import problemList from "../views/common/problemList";
import problemType from "../views/common/problemType";
import yearHistory from "../views/report/06yearHistory";
import year from "../views/report/year";
import openYear from "../views/report/openYear";
import instructions from "../views/map/instructions";
import ta900desc from "../views/map/ta900desc";
import ta2000desc from "../views/map/ta2000desc";
import dailyActive from "../views/status/01dailyActive"
import hr from "../views/status/02hr"
import hrDesc from "../views/status/03hrDesc"
import ecgDesc from "../views/status/04ecgDesc"
import hrvDesc from "../views/status/05hrvDesc"
import sleep from "../views/status/06sleep"
import sleepStage from "../views/status/07sleepStage"
import bos from "../views/status/08bos"
import pressure from "../views/status/09pressure"
import fitnessAge from "../views/status/10fitnessAge"
import staminaLevel from "../views/status/11staminaLevel"
import trainingLoad from "../views/status/12trainingLoad"
import trainingStatus from "../views/status/13trainingStatus"
import vo2max from "../views/status/14vo2max"
import lactate from "../views/status/15lactate"
import forecast2 from "../views/status/16forecast"
import challengeList from "../views/sport/01challengeList"
import challengeHistory from "../views/sport/02challengeHistory"
import challengeDesc from "../views/sport/03challengeDesc"
import sportDesc from "../views/sport/04sportDesc"
import feedback from "../views/my/01feedback"
import newSportList from "../views/report/01list"
import newWeek from "../views/report/02week"
import newMonth from "../views/report/03month"
import newWeekHistory from "../views/report/04weekHistory"
import newMonthHistory from "../views/report/05monthHistory"
import shareHomeLight from '@/views/shareLight/01home'
import myQrLight from "../views/shareLight/02myQr";
import addFriendLight from "../views/shareLight/03addFriend";
import confirmLight from "../views/shareLight/08confirm";
import applyLight from "../views/shareLight/09apply";
import privilegeLight from "../views/shareLight/10privilege";
import phoneLight from "../views/shareLight/11phone";
import confirmAddLight from "../views/shareLight/13confirmAdd";
import friendListLight from "../views/shareLight/04friendList";
import applyListLight from "../views/shareLight/12applyList";
import sportRankLight from "../views/shareLight/07sportRank";
import friendDescLight from "../views/shareLight/14friendDesc";
import personalLight from "../views/shareLight/15personal";
import hrRangeLight from "../views/shareLight/16hrRange";
import findLight from "../views/shareLight/05find";
import selectCityLight from "../views/shareLight/06selectCity";
import unReadListLight from "../views/shareLight/18unReadList";
import msgDescLight from "../views/shareLight/19msgDesc";
import allDynamicsLight from "../views/shareLight/17allDynamics";
import remarkSetLight from "../views/shareLight/20remarkSet";
import sportRecord from "../views/sport/05sportRecord";
import medal from "../views/my/02medal";
import sportCount from "../views/sport/06sportCount"
import points from "../views/my/03points"
import basicHr from "../views/status/17basicHr"
import selectCityApp from "../views/my/04selectCity"
import prodInstructions from "../views/desc/01prodInstructions"
import keepAlive from "../views/desc/02keepAlive.vue"
import privacyAgreement from "../views/my/05privacyAgreement.vue";
import ta700video from "../views/desc/03ta700video.vue"
import water from "../views/status/18water.vue"
import abstract from "../views/status/19abstract.vue"
import weight from "../views/status/20weight.vue"
import planEdit from "../views/trainPlan/01planEdit.vue"
import actionLibrary from "../views/trainPlan/02actionLibrary.vue"
import actionDesc from "../views/trainPlan/03actionDesc.vue"
import actionEdit from "../views/trainPlan/04actionEdit.vue"
import setPlanDate from "../views/trainPlan/05setPlanDate.vue"
import planDesc from "../views/trainPlan/06planDesc.vue"
import planLibrary from "../views/trainPlan/07planLibrary.vue"
import trainCalendar from "../views/trainPlan/08trainCalendar.vue"
import startTrain from "../views/trainPlan/09startTrain.vue"
import sportTrainDesc from "../views/trainPlan/10sportDesc.vue"
import aswear from "../views/third/01aswear.vue"
import activeTarget from "../views/status/21activeTarget.vue"
import userCheckup from "../views/status/22userCheckup.vue"
import checkupDesc from "../views/status/23checkupDesc.vue"
import checkupDeepSeek from "../views/status/24checkupDeepseek.vue"
import sportIndex from "../views/sport/07sportIndex.vue"
import importMp3 from "../views/article/importMp3.vue"
import report from "../views/my/05report"
import nfc from "../views/common/nfc"
import sleepShort from "../views/status/06sleepShort"
import waterSet from "../views/status/18waterSet.vue"
import influenceFactors from "../views/status/25InfluenceFactors.vue"
import recovery from "../views/status/26recovery.vue"
import activity from "../views/status/27activity.vue"
import timeLine from "../views/status/28timeLine.vue"
import sleepNeed from "../views/status/29sleepNeed.vue"
import myJournal from "../views/status/30myJournal.vue"
import sleepAhi from "../views/status/31sleepAhi.vue"
import vitalSigns from "../views/status/32vitalSigns.vue"
import vitalSignsRange from "../views/status/33vitalSignsRange.vue"
import rhythm from "../views/status/34rhythm.vue"

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/share',
            name: 'shareHome',
            component: shareHome,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/myQr',
            name: 'myQr',
            component: myQr,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/addFriend',
            name: 'addFriend',
            component: addFriend,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/confirm',
            name: 'confirm',
            component: confirm,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/apply',
            name: 'apply',
            component: apply,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/privilege',
            name: 'privilege',
            component: privilege,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/phone',
            name: 'phone',
            component: phone,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/qrResult',
            name: 'qrResult',
            component: qrResult,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/confirmAdd',
            name: 'confirmAdd',
            component: confirmAdd,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/friendList',
            name: 'friendList',
            component: friendList,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/applyList',
            name: 'applyList',
            component: applyList,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/sportRank',
            name: 'sportRank',
            component: sportRank,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/qrAdd',
            name: 'qrAdd',
            component: qrAdd,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/friendDesc',
            name: 'friendDesc',
            component: friendDesc,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/condition',
            name: 'condition',
            component: condition,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/forecast',
            name: 'forecast',
            component: forecast,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/personal',
            name: 'personal',
            component: personal,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/hrRange',
            name: 'hrRange',
            component: hrRange,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/find',
            name: 'find',
            component: find,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/selectCity',
            name: 'selectCity',
            component: selectCity,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/unReadList',
            name: 'unReadList',
            component: unReadList,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/msgDesc',
            name: 'msgDesc',
            component: msgDesc,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/allDynamics',
            name: 'allDynamics',
            component: allDynamics,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/share/remarkSet',
            name: 'remarkSet',
            component: remarkSet,
            meta: {
                title: "共享空间"
            }
        }, {
            path: '/report/weekly',
            name: 'weekly',
            component: weekly,
            meta: {
                title: "运动周报"
            }
        }, {
            path: '/report/month',
            name: 'month',
            component: month,
            meta: {
                title: "运动月报"
            }
        }, {
            path: '/report/openYear',
            name: 'openYear',
            component: openYear,
            meta: {
                title: "",
                noKeepAlive: true
            }
        }, {
            path: '/report/year',
            name: 'year',
            component: year,
            meta: {
                title: "运动年报",
                noKeepAlive: true
            }
        }, {
            path: '/report/list',
            name: 'list',
            component: list,
            meta: {
                title: "运动报告"
            }
        }, {
            path: '/report/monthHistory',
            name: 'monthHistory',
            component: monthHistory,
            meta: {
                title: "历史月报"
            }
        }, {
            path: '/report/weeklyHistory',
            name: 'weeklyHistory',
            component: weeklyHistory,
            meta: {
                title: "历史周报"
            }
        }, {
            path: '/report/yearHistory',
            name: 'yearHistory',
            component: yearHistory,
            meta: {
                title: "历史年报"
            }
        }, {
            path: '/article/iosMessageSet',
            name: 'iosMessageSet',
            component: iosMessageSet,
            meta: {
                title: "iosMessageSet.title"
            }
        }, {
            path: '/article/samSet',
            name: 'samSet',
            component: samSet,
            meta: {
                title: "samSet.title"
            }
        }, {
            path: '/article/androidMessageSet',
            name: 'androidMessageSet',
            component: androidMessageSet,
            meta: {
                title: "androidMessageSet.title"
            }
        }, {
            path: '/common/problemList',
            name: 'problemList',
            component: problemList,
            meta: {
                title: "problemList.title",
                noKeepAlive: true
            }
        }, {
            path: '/common/problemType',
            name: 'problemType',
            component: problemType,
            meta: {
                title: "problemType.title",
                noKeepAlive: true
            }
        }, {
            path: '/map/instructions',
            name: 'instructions',
            component: instructions,
            meta: {
                title: "地图使用教程"
            }
        }, {
            path: '/map/ta2000desc',
            name: 'ta2000desc',
            component: ta2000desc,
            meta: {
                title: "地图使用教程"
            }
        }, {
            path: '/map/ta900desc',
            name: 'ta900desc',
            component: ta900desc,
            meta: {
                title: "地图使用教程"
            }
        }, {
            path: '/status/dailyActive',
            name: 'dailyActive',
            component: dailyActive,
            meta: {
                title: "dailyActive.title"
            }
        }, {
            path: '/status/hr',
            name: 'hr',
            component: hr,
            meta: {
                title: "hr.title"
            }
        }, {
            path: '/status/basicHr',
            name: 'basicHr',
            component: basicHr,
            meta: {
                title: "basicHr.title"
            }
        }, {
            path: '/status/hrDesc',
            name: 'hrDesc',
            component: hrDesc,
            meta: {
                title: "hrDesc.title"
            }
        }, {
            path: '/status/ecgDesc',
            name: 'ecgDesc',
            component: ecgDesc,
            meta: {
                title: "ecgDesc.title"
            }
        }, {
            path: '/status/hrvDesc',
            name: 'hrvDesc',
            component: hrvDesc,
            meta: {
                title: "hrvDesc.title"
            }
        }, {
            path: '/status/sleep',
            name: 'sleep',
            component: sleep,
            meta: {
                title: "sleep.title",
                noKeepAlive: true
            }
        }, {
            path: '/status/sleepShort',
            name: 'sleepShort',
            component: sleepShort,
            meta: {
                title: "sleepShort.title",
                noKeepAlive: true
            }
        }, {
            path: '/status/sleepStage',
            name: 'sleepStage',
            component: sleepStage,
            meta: {
                title: "sleepStage.title"
            }
        }, {
            path: '/status/bos',
            name: 'bos',
            component: bos,
            meta: {
                title: "bos.title"
            }
        }, {
            path: '/status/pressure',
            name: 'pressure',
            component: pressure,
            meta: {
                title: "pressure.title"
            }
        }, {
            path: '/status/fitnessAge',
            name: 'fitnessAge',
            component: fitnessAge,
            meta: {
                title: 'fitnessAge.title'
            }
        }, {
            path: '/status/staminaLevel',
            name: 'staminaLevel',
            component: staminaLevel,
            meta: {
                title: "staminaLevel.title"
            }
        }, {
            path: '/status/trainingLoad',
            name: 'trainingLoad',
            component: trainingLoad,
            meta: {
                title: "trainingLoad.title"
            }
        }, {
            path: '/status/trainingStatus',
            name: 'trainingStatus',
            component: trainingStatus,
            meta: {
                title: "trainingStatus.title"
            }
        }, {
            path: '/status/vo2max',
            name: 'vo2max',
            component: vo2max,
            meta: {
                title: "vo2max.title"
            }
        }, {
            path: '/status/lactate',
            name: 'lactate',
            component: lactate,
            meta: {
                title: "lactate.title"
            }
        }, {
            path: '/status/forecast',
            name: 'forecast2',
            component: forecast2,
            meta: {
                title: "forecast.title"
            }
        }, {
            path: '/sport/challengeList',
            name: 'challengeList',
            component: challengeList,
            meta: {
                title: "challengeList.title"
            }
        }, {
            path: '/sport/challengeHistory',
            name: 'challengeHistory',
            component: challengeHistory,
            meta: {
                title: "challengeList.history"
            }
        }, {
            path: '/sport/challengeDesc',
            name: 'challengeDesc',
            component: challengeDesc,
            meta: {
                title: "",
                noKeepAlive: true
            }
        }, {
            path: '/sport/sportDesc',
            name: 'sportDesc',
            component: sportDesc,
            meta: {
                title: ""
            }
        }, {
            path: '/my/feedback',
            name: 'feedback',
            component: feedback,
            meta: {
                title: "feedback.title"
            }
        }, {
            path: '/report/newSportList',
            name: 'newSportList',
            component: newSportList,
            meta: {
                title: "newSportList.title"
            }
        }, {
            path: '/report/newMonth',
            name: 'newMonth',
            component: newMonth,
            meta: {
                title: "newMonth.title",
                noKeepAlive: true
            }
        }, {
            path: '/report/newWeek',
            name: 'newWeek',
            component: newWeek,
            meta: {
                title: "newWeek.title",
                noKeepAlive: true
            }
        }, {
            path: '/report/newMonthHistory',
            name: 'newMonthHistory',
            component: newMonthHistory,
            meta: {
                title: "newMonthHistory.title"
            }
        }, {
            path: '/report/newWeekHistory',
            name: 'newWeekHistory',
            component: newWeekHistory,
            meta: {
                title: "newWeekHistory.title"
            }
        },{
            path: '/shareLight',
            name: 'shareHomeLight',
            component: shareHomeLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/myQr',
            name: 'myQrLight',
            component: myQrLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/addFriend',
            name: 'addFriendLight',
            component: addFriendLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/confirm',
            name: 'confirmLight',
            component: confirmLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/apply',
            name: 'applyLight',
            component: applyLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/privilege',
            name: 'privilegeLight',
            component: privilegeLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/phone',
            name: 'phoneLight',
            component: phoneLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/confirmAdd',
            name: 'confirmAddLight',
            component: confirmAddLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/friendList',
            name: 'friendListLight',
            component: friendListLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/applyList',
            name: 'applyListLight',
            component: applyListLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/sportRank',
            name: 'sportRankLight',
            component: sportRankLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/friendDesc',
            name: 'friendDescLight',
            component: friendDescLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/personal',
            name: 'personalLight',
            component: personalLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/hrRange',
            name: 'hrRangeLight',
            component: hrRangeLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/find',
            name: 'findLight',
            component: findLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/selectCity',
            name: 'selectCityLight',
            component: selectCityLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/unReadList',
            name: 'unReadListLight',
            component: unReadListLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/msgDesc',
            name: 'msgDescLight',
            component: msgDescLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/allDynamics',
            name: 'allDynamicsLight',
            component: allDynamicsLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/shareLight/remarkSet',
            name: 'remarkSetLight',
            component: remarkSetLight,
            meta: {
                title: "共享空间",
                noKeepAlive: true
            }
        }, {
            path: '/sport/sportRecord',
            name: 'sportRecord',
            component: sportRecord,
            meta: {
                title: "sportRecord.title"
            }
        }, {
            path: '/my/medal',
            name: 'medal',
            component: medal,
            meta: {
                title: "medal.title"
            }
        }, {
            path: '/sport/sportCount',
            name: 'sportCount',
            component: sportCount,
            meta: {
                title: "sportCount.title"
            }
        }, {
            path: '/my/points',
            name: 'points',
            component: points,
            meta: {
                title: "我的积分"
            }
        }, {
            path: '/my/selectCity',
            name: 'selectCityApp',
            component: selectCityApp,
            meta: {
                title: "selectCityApp.title"
            }
        }, {
            path: '/desc/prodInstructions',
            name: 'prodInstructions',
            component: prodInstructions,
            meta: {
                title: "prodInstructions.title",
                noKeepAlive: true
            }
        }, {
            path: '/desc/keepAlive',
            name: 'keepAlive',
            component: keepAlive,
            meta: {
                title: "keepAlive.title"
            }
        }, {
            path: '/my/privacyAgreement',
            name: 'privacyAgreement',
            component: privacyAgreement,
            meta: {
                title: "privacyAgreement.title"
            }
        }, {
            path: '/desc/ta700video',
            name: 'ta700video',
            component: ta700video,
            meta: {
                title: "视频操作说明"
            }
        },
        {
            path: '/status/water',
            name: 'water',
            component: water,
            meta: {
                title: "water.title",
                noKeepAlive: true
            }
        },
        {
            path: '/status/waterSet',
            name: 'waterSet',
            component: waterSet,
            meta: {
                title: "waterSet.title",
                noKeepAlive: true
            }
        },
        {
            path: '/status/abstract',
            name: 'abstract',
            component: abstract,
            meta: {
                title: "abstract.title",
                noKeepAlive: true
            }
        },
        {
            path: '/status/weight',
            name: 'weight',
            component: weight,
            meta: {
                title: "weight.title"
            }
        },
        {
            path: '/trainPlan/planEdit',
            name: 'planEdit',
            component: planEdit,
            meta: {
                title: "planEdit.title"
            }
        },
        {
            path: '/trainPlan/actionLibrary',
            name: 'actionLibrary',
            component: actionLibrary,
            meta: {
                title: "actionLibrary.title"
            }
        },
        {
            path: '/trainPlan/actionDesc',
            name: 'actionDesc',
            component: actionDesc,
            meta: {
                title: "actionDesc.title"
            }
        },
        {
            path: '/trainPlan/actionEdit',
            name: 'actionEdit',
            component: actionEdit,
            meta: {
                title: "actionDesc.title"
            }
        },
        {
            path: '/trainPlan/setPlanDate',
            name: 'setPlanDate',
            component: setPlanDate,
            meta: {
                title: "setPlanDate.title",
                noKeepAlive: true
            }
        },
        {
            path: '/trainPlan/planDesc',
            name: 'planDesc',
            component: planDesc,
            meta: {
                title: "planDesc.title",
                noKeepAlive: true
            }
        },
        {
            path: '/trainPlan/planLibrary',
            name: 'planLibrary',
            component: planLibrary,
            meta: {
                title: "planLibrary.title",
                noKeepAlive: true
            }
        },
        {
            path: '/trainPlan/trainCalendar',
            name: 'trainCalendar',
            component: trainCalendar,
            meta: {
                title: "trainCalendar.title",
                noKeepAlive: true
            }
        },
        {
            path: '/trainPlan/startTrain',
            name: 'startTrain',
            component: startTrain,
            meta: {
                title: "startTrain.title",
            }
        },
        {
            path: '/trainPlan/sportTrainDesc',
            name: 'sportTrainDesc',
            component: sportTrainDesc,
            meta: {
                title: "sportTrainDesc.title",
                noKeepAlive: true
            }
        },
        {
            path: '/third/aswear',
            name: 'aswear',
            component: aswear,
            meta: {
                title: "Aswear",
                noKeepAlive: true
            }
        },
        {
            path: '/status/activeTarget',
            name: 'activeTarget',
            component: activeTarget,
            meta: {
                title: "activeTarget.title",
                noKeepAlive: true
            }
        },
        {
            path: '/status/userCheckup',
            name: 'userCheckup',
            component: userCheckup,
            meta: {
                title: "userCheckup.title"
            }
        },
        {
            path: '/status/checkupDesc',
            name: 'checkupDesc',
            component: checkupDesc,
            meta: {
                title: "checkupDesc.title",
                noKeepAlive: true
            }
        },
        {
            path: '/status/checkupDeepSeek',
            name: 'checkupDeepSeek',
            component: checkupDeepSeek,
            meta: {
                title: "checkupDeepSeek.title",
                noKeepAlive: true
            }
        },
        {
            path: '/sport/sportIndex',
            name: 'sportIndex',
            component: sportIndex,
            meta: {
                title: "sportIndex.title",
                noKeepAlive: true
            }
        },
        {
            path: '/article/importMp3',
            name: 'importMp3',
            component: importMp3,
            meta: {
                title: "importMp3.title",
                noKeepAlive: true
            }
        },
        {
            path: '/my/report',
            name: 'report',
            component: report,
            meta: {
                title: "report.title",
                noKeepAlive: true
            }
        },
        {
            path: '/common/nfc',
            name: 'nfc',
            component: nfc,
            meta: {
                title: "nfc.title",
            }
        },
        {
            path: '/status/influenceFactors',
            name: 'influenceFactors',
            component: influenceFactors,
            meta: {
                title: "influenceFactors.title",
            }
        },
        {
            path: '/status/recovery',
            name: 'recovery',
            component: recovery,
            meta: {
                title: "recovery.title",
            }
        },
        {
            path: '/status/activity',
            name: 'activity',
            component: activity,
            meta: {
                title: "activity.title",
            }
        },
        {
            path: '/status/timeLine',
            name: 'timeLine',
            component: timeLine,
            meta: {
                title: "timeLine.title",
            }
        },
        {
            path: '/status/sleepNeed',
            name: 'sleepNeed',
            component: sleepNeed,
            meta: {
                title: "sleepNeed.title",
            }
        },
        {
            path: '/status/myJournal',
            name: 'myJournal',
            component: myJournal,
            meta: {
                title: "myJournal.title",
            }
        },
        {
            path: '/status/sleepAhi',
            name: 'sleepAhi',
            component: sleepAhi,
            meta: {
                title: "sleepAhi.title",
            }
        },
        {
            path: '/status/vitalSigns',
            name: 'vitalSigns',
            component: vitalSigns,
            meta: {
                title: "vitalSigns.title",
            }
        },
        {
            path: '/status/vitalSignsRange',
            name: 'vitalSignsRange',
            component: vitalSignsRange,
            meta: {
                title: "vitalSigns.title",
            }
        },
        {
            path: '/status/rhythm',
            name: 'rhythm',
            component: rhythm,
            meta: {
                title: "rhythm.title",
            }
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js